import React, { Component } from 'react'
import styles from "./ImgInteract.module.css"

import MaskWrapper from "./MaskWrapper"
const SCALE_SPEED = 4
export default class ImgInteract extends Component {

    constructor(props) {
        super(props)

        // props.state to set the reserve state
        this.state = {
            imgWidth: (props.state && props.state.imgWidth) ? (props.state.imgWidth) : 100,  //%
            imgHeight: (props.state && props.state.imgHeight) ? (props.state.imgHeight) : 100, //%
            imgPosX: (props.state && props.state.imgPosX) ? (props.state.imgPosX) : 0,     //px
            imgPosY: (props.state && props.state.imgPosY) ? (props.state.imgPosY) : 0,     //px
            src: (props.state && props.state.src) ? (props.state.src) : 0
        }

        //local resource
        this.node = null
        this.enable = false
        this.preventDragFlag = false
        this.mousePos = { x: 0, y: 0 };
    }
    // callback
    maskTriggerCallback = (status) => { this.preventDragFlag = status }

    // Handler
    maskHandler = (e) => {
        console.log(e)
    }
    dragHandler = (e) => {
        e.preventDefault();
        if (this.enable && this.preventDragFlag == false) {
            var shiftX = e.clientX - this.mousePos.x
            var shiftY = e.clientY - this.mousePos.y

            this.setState(state => {
                return {
                    imgPosX: shiftX,
                    imgPosY: shiftY,
                }
            })
        }
    }
    enableHandler = (e) => {
        if (this.props.state.select != true)
            return
        this.enable = true
        this.mousePos.x = e.clientX - this.state.imgPosX;
        this.mousePos.y = e.clientY - this.state.imgPosY;
    }
    disableHandler = (e) => { this.enable = false }

    scaleHandler = (e) => {
        if (this.props.state.select != true)
            return

        var scale = 0;
        if (e.deltaY < 0) {
            scale += SCALE_SPEED;
        } else {
            scale -= SCALE_SPEED;
        }

        this.setState(state => {
            return {
                imgWidth: state.imgWidth + scale,
                imgHeight: state.imgHeight + scale,
            }
        })
    }

    // life-cycle handler
    componentDidUpdate() {
        //update it img src
        this.setState(state => {
            if (state.src != this.props.state.src) {
                return { src: this.props.state.src }
            } else {
                this.props.updateStateCB(this.state)
            }
        }, () => { this.props.updateStateCB(this.state) })
    }
    componentDidMount() { }
    componentWillUnmount() { }

    render() {

        // object-position: 10px 10px;
        // width and height
        const imgStyle = {
            objectPosition: `${this.state.imgPosX}px ${this.state.imgPosY}px`,
            width: `${this.state.imgWidth}%`,
            height: `${this.state.imgHeight}%`,
        }
        return (
            <div id={this.props.id} className={styles.container}
                onMouseMove={this.dragHandler}
                onMouseDown={this.enableHandler}
                onMouseUp={this.disableHandler}
                onWheel={this.scaleHandler}
            >
                <div className={styles.imgWrapper}>
                    <MaskWrapper maskTriggerCallback={this.maskTriggerCallback} select={this.props.state.select} />
                    <img id={this.props.id} style={imgStyle} className={styles.imgStyle} src={this.state.src} alt="" srcSet="" />
                </div>
            </div>
        )
    }
}
